var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { styledWithTheme } from '../../style/theme';
import { IconButton } from './icon-button';
var Button = styledWithTheme(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: ", ";\n"], ["\n  box-shadow: ", ";\n"])), function (p) { return p.theme.boxShadows.medium; });
export var FloatingIconButton = function (props) { return (React.createElement(Button, __assign({ variant: "fill" }, props))); };
var templateObject_1;
//# sourceMappingURL=floating-icon-button.js.map